const ACCESS_KEY = 'authToken';
const REFRESH_KEY = 'refreshToken';

/**
 * El login guarda los tokens siempre en sessionStorage y, con "remember", también en
 * localStorage. Al leer se prefiere sessionStorage, igual que el interceptor de la API.
 */
const read = (key) => sessionStorage.getItem(key) ?? localStorage.getItem(key);

export const getAuthToken = () => read(ACCESS_KEY);
export const getRefreshToken = () => read(REFRESH_KEY);

/**
 * Guarda los tokens en el/los storage donde ya vivía la sesión, para no convertir una
 * sesión sin "remember" en una persistente (ni al revés). Sin sesión previa, cae en
 * sessionStorage.
 */
export const saveTokens = ({ token, refreshToken }) => {
    const stores = [sessionStorage, localStorage].filter(
        (store) => store.getItem(ACCESS_KEY) !== null || store.getItem(REFRESH_KEY) !== null
    );
    (stores.length ? stores : [sessionStorage]).forEach((store) => {
        if (token) store.setItem(ACCESS_KEY, token);
        if (refreshToken) store.setItem(REFRESH_KEY, refreshToken);
    });
};

export const clearTokens = () => {
    [sessionStorage, localStorage].forEach((store) => {
        store.removeItem(ACCESS_KEY);
        store.removeItem(REFRESH_KEY);
    });
};
